import { Validator } from '@vista-digital/validator';
import { nonEmptyStringValidator } from './string';
export const voucherCredentialsValidator = Validator.object({
    barcode: nonEmptyStringValidator,
    pin: Validator.optional(nonEmptyStringValidator)
});
